/**
 * 表格时间格式化
 */
import {imageServerUrl, webServer} from "@/utils/constant";
import cache from "@/utils/cache";
import {getDeviceId} from "@/utils/auth";

export function formatDate(date, format) {
  format = format || 'yyyy-MM-dd hh:mm:ss';
  if (date) {
    if (date.time) {
      const dateT = new Date()
      dateT.setTime(date.time)
      date = dateT
    }
    const o = {
      "M+": (date.getMonth() || 0) + 1, //month
      "d+": date.getDate() || 1, //day
      "h+": date.getHours() || 1, //hour
      "m+": date.getMinutes() || 0, //minute
      "s+": date.getSeconds() || 0, //second
      "q+": Math.floor((date.getMonth() + 3) / 3) || 1, //quarter
      "S": date.getMilliseconds() || 0 //millisecond
    };

    if (/(y+)/.test(format)) {
      format = format.replace(RegExp.$1, ((date.getFullYear() || 1970) + "").substr(4 - RegExp.$1.length));
    }
    if (/(w+)/.test(format)) {
      format = format.replace(RegExp.$1, ((date.getDay() || 6) + 1 + ""));
    }

    for (let k in o) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }
    return format;
  } else {
    return ""
  }
}
export function parseDate(input) {
  return new Date(input.replace(/-/g, "/"))
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return parseTime(time, '{y}年{m}月{d}日 {h}时{i}分')
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} str value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (let i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {number}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date().getTime()
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = () => {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return (...args) => {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function deepSet(source, targetObj, set) {
  if (typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  if (typeof targetObj !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  if (typeof set !== 'function') {
    throw new Error('error arguments', 'deepClone')
  }
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      set(targetObj, keys, deepSet(source[keys], targetObj, set))
    } else {
      set(targetObj, keys, source[keys])
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) << 16) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(elm, cls) {
  return !!elm.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(elm, cls) {
  if (!hasClass(elm, cls)) elm.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(elm, cls) {
  if (hasClass(elm, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    elm.className = elm.className.replace(reg, ' ')
  }
}

export function makeMap(str, expectsLowerCase) {
  const map = Object.create(null)
  const list = str.split(',')
  for (let i = 0; i < list.length; i++) {
    map[list[i]] = true
  }
  return expectsLowerCase
    ? val => map[val.toLowerCase()]
    : val => map[val]
}

// 首字母大小
export function titleCase(str) {
  return str.replace(/( |^)[a-z]/g, L => L.toUpperCase())
}

// 下划转驼峰
export function camelCase(str) {
  return str.replace(/-[a-z]/g, str1 => str1.substr(-1).toUpperCase())
}

export function isNumberStr(str) {
  return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(str)
}

/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
  let search = params;
  search.params = {};
  if (dateRange) {
    if (typeof (propName) === "undefined") {
      search.params["beginTime"] = dateRange[0];
      search.params["endTime"] = dateRange[1];
    } else {
      search.params["begin" + propName] = dateRange[0];
      search.params["end" + propName] = dateRange[1];
    }
  }
  return search;
}

// 通用下载方法
export function download(sourceName, fileName) {
  const url = webServer + "/common/download?fileName=" + encodeURI(sourceName) + "&delete=" + true;
  const a = document.createElement('a')
  a.setAttribute('download', fileName || sourceName)
  a.setAttribute('target', '_blank')
  a.setAttribute('href', url)
  a.click()
}

// 字符串格式化(%s )
export function sprintf(str) {
  let args = arguments, flag = true, i = 1;
  str = str.replace(/%s/g, () => {
    let arg = args[i++];
    if (typeof arg === 'undefined') {
      flag = false;
      return '';
    }
    return arg;
  });
  return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function parseStrEmpty(str) {
  if (!str || str === "undefined" || str === "null") {
    return "";
  }
  return str;
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 * @param {*} rootId 根Id 默认 0
 */
export function handleTree(data, id, parentId, children, rootId) {
  id = id || 'id'
  parentId = parentId || 'parentId'
  children = children || 'children'
  rootId = rootId || Math.min.apply(Math, data.map(item => {
    return item[parentId]
  })) || 0
  //对源数据深度克隆
  const cloneData = JSON.parse(JSON.stringify(data))
  //循环所有项
  const treeData = cloneData.filter(father => {
    let branchArr = cloneData.filter(child => {
      //返回每一项的子级数组
      return father[id] === child[parentId]
    });
    branchArr.length > 0 ? father.children = branchArr : '';
    //返回第一层
    return father[parentId] === rootId;
  });
  return treeData !== '' ? treeData : data;
}

export function getType(obj) {
  let type = typeof obj;

  if (type !== 'object') {
    return type;
  }
  //如果不是object类型的数据，直接用typeof就能判断出来
  //如果是object类型数据，准确判断类型必须使用Object.prototype.toString.call(obj)的方式才能判断
  return Object.prototype.toString.call(obj).replace(/^\[object (\S+)]$/, '$1');
}

export function isObject(obj) {
  return getType(obj) === 'Object'
}

export function isString(obj) {
  return getType(obj) === 'string'
}

export function isBoolean(obj) {
  return getType(obj) === 'boolean'
}

export function isArray(obj) {
  if (typeof Array.isArray === 'undefined') {
    return getType(obj) === 'Array'
  }
  return Array.isArray(obj)
}

export function isFunction(obj) {
  return getType(obj) === 'function';
}

export function isUndefined(obj) {
  return getType(obj) === 'undefined';
}

export function scrollTop() {
  window.scrollTo(0, 0)
}

function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}

export function guid() {
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

export function guidSimple() {
  return (S4() + S4() + S4() + S4() + S4() + S4() + S4() + S4());
}

export function isAgreePrivacy() {
  return cache.get("isAgreePrivacy") === 'true'
}

export function buildUrl(url) {
  if (url) {
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    } else {
      return imageServerUrl + url;
    }
  }
  return "";
}

export function getParameterByName(name) {
  var match = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
  if (match && match.length > 0) return decodeURIComponent(match[1]);
}

export function sort(array, keys) {
  if (isArray(array)) {
    if (isString(keys)) {
      keys = [keys];
      array.sort((m, n) => {
        if (m && n) {
          for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            if (key && isString(key)) {
              let sortDesc = true;
              if (key.startsWith("-")) {
                key = key.substring(1)
                sortDesc = false;
              }
              if (m[key] !== n[key]) {
                if (sortDesc) {
                  return m[key] > n[key] ? 1 : -1
                } else {
                  return m[key] < n[key] ? 1 : -1
                }
              }
            }
          }
          return 0;
        }
      })

    }
  }
}

//

export function setBackUrl(backUrl) {
  cache.set("backUrl", backUrl || '')
}

export function changePage(router, url, noHistory, backUrl) {
  if (backUrl) {
    setBackUrl(backUrl)
  }
  if (url === location.pathname || ('#' + url) === location.hash) {
    return
  }
  if (url.startsWith("#/")) {
    url = url.substring(1)
  }
  if (url && url.startsWith("http")) {
    location.href = url
    return;
  }
  if (url && (url.startsWith("/chinaMerger") || url.startsWith("chinaMerger"))) {
    location.href = url
    return;
  }
  if (noHistory) {
    router.replace(url)
  } else {
    router.push(url)
  }
}

export function changePageNext(next, url, redirect) {
  if (redirect && !redirect.startsWith("/http")) {
    setBackUrl(redirect)
  }
  next(url)
  // setTimeout(() => {
  //   location.reload()
  // },100)
}

export function goToBackUrl(router, noHistory, defaultUrl) {
  return new Promise((resolve) => {
    let backUrl = cache.get("backUrl") || getParameterByName("redirect");
    if (backUrl) {
      if (!backUrl.startsWith("/")) {
        backUrl = "/" + backUrl;
      }
      cache.remove("backUrl")
      changePage(router, backUrl, noHistory)
    } else {
      changePage(router, defaultUrl || "/", noHistory)
    }
    resolve()
  })
}

export function openUrl(store, url, type) {
  if (store && store.getters && store.getters.isWeiXin) {
    location.href = url;
  } else {
    type ? window.open(url, type) : window.open(url)
  }
}

export function consoleLog(...any) {
  console.log(...any)
}

export function getSprad() {
  return getParameterByName("sprad") || cache.get("sprad") || '';
}

export function setSprad(sprad) {
  if (sprad) {
    cache.set("sprad", sprad);
  }
}

export function getShareRegister() {
  return getParameterByName("shareRegister") || cache.get("shareRegister");
}

export function setShareRegister(shareRegister) {
  cache.set("shareRegister", shareRegister || "");
}

export function getPlatformChannel() {
  const platformChannel = cache.get("platformChannel");
  if (platformChannel) {
    const json = JSON.parse(platformChannel);
    if (json.date > new Date().getTime()) {
      return json.platformChannel;
    }
  }
  return "";
}

export function setPlatformChannel(platformChannel) {
  if (platformChannel) {
    cache.set("platformChannel", JSON.stringify({
      date: new Date().getTime() + 24 * 60 * 60 * 1000,
      platformChannel: platformChannel
    }))
  }
}

export function mTimeout(fn, timeout) {
  let timeoutIndex
  const p = new Promise((resolve, reject) => {
    if (isFunction(fn)) {
      timeoutIndex = setTimeout(() => {
        try {
          resolve(fn())
        } catch (e) {
          reject(e)
        }
      }, timeout)
    }
    resolve()
  })
  return {p: p, timeoutIndex: timeoutIndex}
}

export function createPiwikUrl(title, subTitle, store, notDoCreate) {
  if (notDoCreate) return;
  let result = "https://pik.chinamerger.com/piwik.php?idsite=14&rec=1";
  if (store.state.user && store.state.user.userId) {
    result += "&uid=" + store.state.user.userId;
  }
  /* else {
   if (!$scope.pikUserId) $scope.pikUserId = ChinaMerger.guid();
   result += "&uid=" + $scope.pikUserId;
   }*/
  const deviceId = getDeviceId()
  return result + "&action_name=" + encodeURIComponent(title + (subTitle ? "_" + subTitle : '')) + "&url=" +
    encodeURIComponent(getUrl()) + (deviceId ? '&_id=' + deviceId : '');
}

function getUrl() {
  let search = location.search ? location.search.substr(1).replace(/=/g, "___") : "";
  return location.protocol + "//" + location.host + "?_=" + location.pathname + "&ss=" + search
}

export function isSpider(ua) {
  return ua && /[\s\S]*(Baiduspider|bingbot|Googlebot|YisouSpider|spider|MJ12bot|YandexBot|SemrushBot|DotBot|Bytespider)[\s\S]*/i.test(ua);
}

export function replaceMeta(str) {
  if (str) {
    return str.replace(/；/g, ";").replace(/。/g, ".").replace(/，/g, ",").replace(/：/g, ":")
  }
  return ""
}

export function getStrByteLength(str) {
  return str.replace(/[\u0000-\u007f]/g, "a").replace(/[\u0080-\u07ff]/g, "aa").replace(/[\u0800-\uffff]/g, "aaa").length;
}

export function addParam(url, key, val) {
  if (!url) return url;
  if (!key) return url;
  if (url.indexOf("?") > -1) {
    url += "&" + key + "=" + (val || '');
  } else {
    url += "?" + key + "=" + (val || '');
  }
  return url;
}

export function replaceUrlLanguageByDomain(url) {
  if (url) {
    if (document.domain.indexOf("en") >= 0) {
      return url.replace(/zh_CN/g, "en_US");
    }
  }
  return url;
}
